// extracted by mini-css-extract-plugin
export default {"screen-title":"styles_screen-title__zyhHj","title":"styles_title__0J0Bc","description":"styles_description__ggXF3"};